<template>
  <b-card class="cardStyle mb-3">
    <p class="m-0 mb-2 title">
      Study Recruitment Period
    </p>
    <div v-if="loading" id="loading" class="text-center">
      <b-spinner class="align-middle" label="Spinning" type="grow"></b-spinner>
    </div>
    <section v-if="!loading">
      <section v-if="Object.keys(dates).length > 0">
        <div class="d-flex justify-content-between dateStyle">
          <p class="mb-0 text-left">
            Start ({{ startStatus }}):
            <span style="color: #0064C1;">{{ formatDate(startDate) }}</span>
          </p>
          <p class="mb-0">
            End ({{ endStatus }}):
            <span style="color: #0064C1;">{{ formatDate(endDate) }}</span>
          </p>
        </div>
        <b-progress :max="max" class="mb-2" height="2.5rem">
          <b-progress-bar :style="progressColor" :value="parseFloat(elapsed)"> </b-progress-bar>
        </b-progress>
        <b-row class="dateStyle">
          <b-col v-if="startStatus !== '-'" class="mb-0 text-left">
            <b-icon icon="circle-fill" style="color:rgba(64, 64, 215, 0.54)"></b-icon>&nbsp;
            &nbsp;Elapsed ({{ elapsed }} months)
          </b-col>
          <b-col v-if="endStatus !== '-' && showRemaining" class="mb-0 text-right">
            <b-icon icon="circle-fill" style="color:#e9ecef"></b-icon>&nbsp;&nbsp;Remaining ({{
              remaining
            }}
            months)
          </b-col>
        </b-row>
        <div v-if="canRedirectToEnrollment" class="d-flex justify-content-center">
          <b-button class="redirectLink" variant="link" @click="redirect()">
            Go to Enrollment details
          </b-button>
        </div>
      </section>
      <section v-if="!Object.keys(dates).length > 0" class="text-center mt-4">
        <strong class="text-dark">
          There are no study milestones data to display at this time.
        </strong>
      </section>
    </section>
  </b-card>
</template>

<script>
  import moment from 'moment';

  export default {
    props: {
      siteId: String,
      studyId: String,
      canRedirectToEnrollment: Boolean,
    },
    data() {
      return {
        today: '',
        startDate: '',
        endDate: '',
        startStatus: '',
        endStatus: '',
        elapsed: null,
        remaining: null,
        loading: false,
        dates: [],
        max: null,
        showRemaining: true,
      };
    },
    computed: {
      isEnrollmentOversight() {
        return this.$route.name.includes('oversight');
      },
      progressColor() {
        return this.max > 0
          ? 'background: linear-gradient(270deg, #0000C9 0%, rgba(64, 64, 215, 0.54) 100%);opacity:0.6; '
          : 'background:#e9ecef';
      },
    },
    created() {
      this.getDatesFromCordis();
    },
    methods: {
      setData() {
        this.today = moment();
        //start date
        this.setStartDate();
        //end data
        this.setEndDate();

        if (this.startStatus !== '-' && this.endStatus !== '-') {
          let maxVal = this.endDate.diff(this.startDate, 'months', true).toFixed(1);
          this.max = parseFloat(maxVal);

          if (moment(this.today).isSameOrAfter(this.endDate)) {
            this.elapsed = this.max;
            this.remaining = 0;
            this.showRemaining = false;
          } else {
            this.elapsed = moment(this.today)
              .diff(this.startDate, 'months', true)
              .toFixed(1);
            this.remaining = this.endDate.diff(this.today, 'months', true).toFixed(1);
          }
        } else if (this.startStatus !== '-') {
          this.elapsed = this.today.diff(this.startDate, 'months', true).toFixed(1);
        } else if (this.endStatus !== '-') {
          this.remaining = this.endDate.diff(this.today, 'months', true).toFixed(1);
          if (this.remaining < 0) {
            this.remaining = 0;
            this.max = 1;
            this.elapsed = 1;
            this.showRemaining = false;
          }
        }
      },
      setStartDate() {
        if ('actualFSFV' in this.dates) {
          this.startDate = moment(this.dates['actualFSFV']);
          this.startStatus = 'Actual FSFV';
        } else if ('plannedFSFV' in this.dates) {
          this.startDate = moment(this.dates['plannedFSFV']);
          this.startStatus = 'Planned FSFV';
        } else {
          this.startDate = 'N/A';
          this.startStatus = '-';
        }
      },
      setEndDate() {
        if ('actualLSFV' in this.dates) {
          this.endDate = moment(this.dates['actualLSFV']);
          this.endStatus = 'Actual LSFV';
        } else if ('plannedLSFV' in this.dates) {
          this.endDate = moment(this.dates['plannedLSFV']);
          this.endStatus = 'Planned LSFV';
        } else {
          this.endDate = 'N/A';
          this.endStatus = '-';
        }
      },
      async getDatesFromCordis() {
        try {
          this.loading = true;
          let response = await axios.get(`/api/cordis/milestones/${this.studyId}`);
          this.dates = response.data['studyMilestones'];
          this.setData();
        } catch (error) {
          console.error(error);
        }
        this.loading = false;
      },
      formatDate(date) {
        if (date == null || date === 'N/A') {
          return 'N/A';
        } else {
          return moment(date).format('DD MMM YYYY');
        }
      },
      redirect() {
        this.$router.push({
          name: this.isEnrollmentOversight ? 'oversight-site-enrollment' : 'site-enrollment',
          params: {
            siteId: this.$route.params['siteId'],
            studyId: this.$route.params['studyId'],
          },
        });
      },
    },
  };
</script>

<style scoped>
  .title {
    font-weight: 400;
    font-size: 22px;
    line-height: 24px;
    letter-spacing: 0.25px;
    color: #0064c1;
    text-align: center;
  }
  .redirectLink {
    font-weight: 400;
    font-size: 16px;
    line-height: 10px;
    text-align: center;
    letter-spacing: 0.25px;
    text-decoration-line: underline;
    color: #3c45ea;
    cursor: pointer;
    margin-top: 1rem;
  }
  .dateStyle {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: right;
    letter-spacing: 0.25px;
    color: #383838;
  }
</style>
